var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AppDetailPreviewVideoContainer, TemplateInfoMediaItemContainer, TemplateMoreInfoScreenshot, } from '../styles';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
var TemplateInfoMediaItem = function (_a) {
    var imageUrl = _a.imageUrl, type = _a.type, index = _a.index, itemId = _a.itemId;
    var visibility = React.useContext(VisibilityContext);
    var visible = visibility.isItemVisible(itemId);
    return (_jsx(TemplateInfoMediaItemContainer, { children: type === 'video' ? (_jsx(_Fragment, { children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes('.gif')) ? (_jsx(TemplateMoreInfoScreenshot, { visible: visible, firstItem: index === 0, src: "".concat(process.env.TWICPICS_MEDIA_BUCKET_URL, "/").concat(imageUrl), alt: "template_img" }, imageUrl)) : (_jsx(AppDetailPreviewVideoContainer, __assign({ controls: true, muted: true, loop: true, visible: visible, controlsList: "nofullscreen" }, { children: _jsx("source", { src: "".concat(process.env.AWS_S3_CLOUDFRONT_VIDEO_URL, "/").concat(imageUrl), type: "video/mp4" }) }))) })) : (_jsx(TemplateMoreInfoScreenshot, { visible: visible, firstItem: index === 0, src: "".concat(process.env.TWICPICS_MEDIA_BUCKET_URL, "/").concat(imageUrl), alt: "template_img" }, imageUrl)) }));
};
export default TemplateInfoMediaItem;
